import type { FeedItemDto } from './feed.dto';
import { z } from 'zod';

export interface MemberStatusChangeRequestProcessResult {
  id: number;
  memberId: string;
  interactionEffectiveAt: string;
  effectiveAt: string;
}

export interface MemberStatusChangeRequestProcess {
  id: number;
  memberId: string;
  interactionEffectiveAt: number;
  effectiveAt: number;
}

export interface NewMemberStatusChangeRequestViewDto {
  memberStatusChangeRequest: MemberStatusChangeRequestDto;
  feedItem: FeedItemDto;
}

export interface PatchMemberStatusChangeRequestViewDto {
  memberStatusChangeRequest: MemberStatusChangeRequestDto;
  feedItem: FeedItemDto;
}

export interface MemberStatusChangeRequestDto {
  id: number;
  creatorId: string;
  memberId: string;
  memberStatusId: number;
  interactionId: number;
  creatorComment: string;
  auditorComment: string;
  effectiveAt: number;
  approvedAt: number;
  deniedAt: number;

  createdAt: number;
}

export const MemberStatusChangeRequestFormSchema = z.object({
  id: z.number().nullable().optional(),
  memberId: z.string(),
  effectiveAt: z.string(),
  interactionId: z.number().nullable().optional(),
  memberStatusId: z.number(),
  creatorComment: z.string().nullable(),
  approval: z.enum(['deny', 'approve']).nullable(),
});

export const MemberStatusChangeRequestAuditFormSchema = z.object({
  id: z.number().nullable().optional(),
  memberId: z.string(),
  effectiveAt: z.string(),
  interactionId: z.number().nullable().optional(),
  memberStatusId: z.number(),
  creatorComment: z.string().nullable(),
  approval: z.enum(['deny', 'approve']).nullable(),
  auditorComment: z.string(),
});

export type MemberStatusChangeRequestForm = z.infer<
  typeof MemberStatusChangeRequestFormSchema
>;
export type MemberStatusChangeRequestAuditForm = z.infer<
  typeof MemberStatusChangeRequestAuditFormSchema
>;
